import { Directive } from '@angular/core';
import { ViewContainerRefDir } from '../core/view-container-ref.directive';

@Directive({
  selector: '[libSnackbar]'
})
export class SnackbarDirective extends ViewContainerRefDir { }
